import ChemistryScore from './ChemistryScore';

export default ChemistryScore;
